<ng-container *ngIf="syncState$ | async as syncState">
    <div (click)="triggerSynchronization()" class="syncIconWrapper cursor-pointer">
        <fa-icon *ngIf="syncState === online" [icon]="faSync" size="lg" class="icon-online"></fa-icon>
        <fa-icon *ngIf="syncState === offline" [icon]="faBan" size="lg" class="icon-offline"></fa-icon>
        <fa-icon *ngIf="syncState === syncing" [icon]="faSync" [spin]="true" size="lg" class="icon-online"></fa-icon>
        <fa-icon *ngIf="syncState === pending" [icon]="faUpload" size="lg" class="icon-offline"></fa-icon>
        <ng-container *ngIf="count$ | async as count">
            <span *ngIf="count > 0" class="badge rounded-pill bg-danger">{{ count }}</span>
        </ng-container>
    </div>
</ng-container>
